import { useTranslation } from 'react-i18next';

import Step1 from '@/images/steps/step1.svg';
import Step2 from '@/images/steps/step2.svg';
import Step3 from '@/images/steps/step3.svg';

function PDFEditSteps() {
	const { t } = useTranslation();
	const steps = t('home.howTo.steps', { returnObjects: true });

	const SignStepList = [
		{
			stepImg: Step1,
			texts: steps[0]
		},
		{
			stepImg: Step2,
			texts: steps[1]
		},
		{
			stepImg: Step3,
			texts: steps[2]
		}
	];
	return (
		<div className="flex w-full flex-col justify-between gap-y-8 lg:flex-row">
			{SignStepList.map((signStep, index) => {
				return (
					<div
						className="mx-auto flex w-[291px] flex-col leading-[21px] lg:mx-0"
						key={index + signStep.texts.title}
					>
						<span className="mb-4 flex h-10 w-10 flex-col items-center justify-center rounded-[70px] bg-black px-1 py-0.5 text-2xl font-bold leading-9 text-white">
							{index + 1}
						</span>
						<div className="mb-5 flex h-[116px] w-[293px] items-center justify-center rounded-lg bg-white">
							<img
								src={signStep.stepImg}
								alt={`${t('labels.step')} ${index}`}
								width="228"
								height="93"
								loading="lazy"
							/>
						</div>
						<span className="font-serif mb-2 text-left font-semibold leading-7">
							{signStep.texts.title}
						</span>
						<p className="text-sm font-normal leading-6 text-grey-500">
							{signStep.texts.description}
						</p>
					</div>
				);
			})}
		</div>
	);
}

export default PDFEditSteps;
